import { connectSearchBox } from 'instantsearch.js/es/connectors'
import { getPageId, getAllIngredientValues, getSearchInputValue, postRequestExist } from './../../../../algolia/helper';

const renderSearchBox = (renderOptions, isFirstRender) => {
    const { refine, widgetParams, clear, query } = renderOptions;
    const { placeholder, searchBoxAriaLabel } = widgetParams;

    if(!isFirstRender) {
        return;
    }

    widgetParams.container.innerHTML = `
    <form class="barreRecherche-interne form-group" action="#" method="post">
        <div class="form-group">
            <input
                name="input_name[]"
                id="inputBarreVisible"
                type="text"
                class="form-control form-control-lg"
                placeholder="${placeholder}"
                aria-label="${searchBoxAriaLabel}"
            >
            <button class="ais-SearchBox-reset" type="reset" title="Clear the search query."></button>
        </div>
    </form>`

    widgetParams.container.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
    });

    /**
     * Evenement lorsqu'on ecris dans le champs de recherche
     */
    widgetParams.container.querySelector('input').addEventListener('input', event => {
        event.preventDefault();

        if(event.target.value.length > 0){
            $('.ais-SearchBox-reset').show();
        }

        saveCookieQuery();
        let ingredientValue = getAllIngredientValues();

        // S'il y a pas d'ingrédient de selectionné, lancer la recherche seule
        if(ingredientValue.length === 0) {
            refine(event.target.value);
        // Si un ou des ingrédients est selectionné, lancer la recherche avec les valeurs des ingrédients
        } else {
            refine(event.target.value + " " + getAllIngredientValues().join(' '));
        }
    });

    widgetParams.container.querySelector('.ais-SearchBox-reset').addEventListener('click', event => {

        // Relance la recherche s'il y a des ingrédients, la met à 0 s'il n'y en a pas
        let ingredients = getAllIngredientValues();
        if(ingredients.length > 0){
            refine(ingredients.join(" "));
        } else {
            clear();
        }

        resetCookieQuery();

        // Masque la croix
        $(this).hide();
    });

    /**
     * Recupère le cookie qui contient la recherche précédement effectué et l'affiche dans l'input
     */
    let searchBoxQuery = getCookieQuery();

    // Si le cookie n'existe pas où qu'il y a une requet POST
    if(searchBoxQuery === undefined || postRequestExist() === 1){
        widgetParams.container.querySelector('input').value = query;
       
    // Sinon definir la valeur de la query d'algolia par defaut
    } else {
        widgetParams.container.querySelector('input').value = searchBoxQuery;
    }

    // Masque la croix du champ de recherche s'il n'y est vide
    if(getSearchInputValue().length === 0){
        $('.ais-SearchBox-reset').hide();
    }


};


/**
 * Sauvegarde le cookie qui est utilisé rééafficher le contenu de la recherche précédement faite lors d'un changement de page
 */
function saveCookieQuery()
{
    const cookieValue = `recette_query_${getPageId()}=${getSearchInputValue()}; SameSite=Strict`;
    document.cookie = cookieValue;
}

function resetCookieQuery()
{
    const cookieValue = `recette_query_${getPageId()}=; SameSite=Strict`;
    document.cookie = cookieValue;
}

function getCookieQuery()
{
    return $.cookie(`recette_query_${getPageId()}`);
}

const customSearchBox = connectSearchBox(renderSearchBox);

export default customSearchBox;